<div [class]="'tag ' + colorClass" data-test-class="tag">
	<ng-content />
</div>
